/**
 * Copy text to clipboard with graceful fallback for contexts where
 * navigator.clipboard is unavailable (insecure origin, sandboxed iframes,
 * older browsers, some test runners).
 */
export async function copyToClipboard(text) {
  if (typeof window === 'undefined' || !text) return false;
  // Preferred: async Clipboard API (requires secure context)
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch { /* fall through */ }
  // Fallback: legacy execCommand with a temporary textarea
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'absolute';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
